<div class="radio-group-container">
  @if (label()) {
    <label>{{ label() }}</label>
  }
  <mat-radio-group
    [formControl]="control"
    [class.vertical]="vertical()"
    color="primary"
    [attr.aria-label]="label()"
    (blur)="onTouched()"
  >
    @for (option of options(); track option) {
      <mat-radio-button [disabled]="isDisabled()" [value]="option.value">
        {{ option.label }}
      </mat-radio-button>
    }
  </mat-radio-group>
  @if (control?.invalid && control?.touched) {
    <mat-error>
      {{ getErrorMessage() }}
    </mat-error>
  }
</div>
